import {withTheme} from '@rn-vui/themed';

import Text, {TextProps} from '../ui-controls/Text';

export default withTheme<TextProps>(Text, 'LMGText');

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    LMGText: Partial<TextProps | {color?: string}>;
  }
}
